var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"mask",style:({
      width: ("calc(100vw - " + _vm.scrollWidth + "px)"),
      marginLeft: _vm.scrollWidth + 'px'
    })},[_c('div',{staticClass:"main"},[_c('a-spin',{attrs:{"tip":"努力加载中...","size":"large"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c145775c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tools/loading.vue
// module id = null
// module chunks = 